"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require("immutable"),
    Map = _require.Map;

var styleReducer = function styleReducer(acc, curr) {
  Object.keys(curr).forEach(function (key) {
    acc[key] = _objectSpread2({}, acc[key], {}, curr[key]);
  });
  return acc;
};
/**
 * Simple class for managing styles in the Bento world
 */


var Theme =
/*#__PURE__*/
function () {
  function Theme(theme) {
    var _this = this;

    _classCallCheck(this, Theme);

    var map = Map({});

    for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      props[_key - 1] = arguments[_key];
    }

    var newTheme = map.mergeDeep.apply(map, [theme].concat(props)).toJS(); // v5 All keys should be added to root.

    Object.keys(newTheme).forEach(function (key) {
      _this[key] = newTheme[key];
    });
  }
  /**
   * Add whatever you need to the theme
   * @param styles - array or object
   * @returns {Theme}
   */


  _createClass(Theme, [{
    key: "add",
    value: function add(styles) {
      var val = Array.isArray(styles) ? styles.reduce(styleReducer, {}) : styles;
      return new Theme(this, val);
    }
  }]);

  return Theme;
}();

exports["default"] = Theme;